
import api from './index';
let exports = {};

// 获取资产定义已关联组装件列表
exports.getAsmblAccDefList = function (data, callback) {
    api.post('/mercht/devc/acc/asmbl/list/get')
    .data(data)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devcDef.js
// module id = 513
// module chunks = 1